// extracted by mini-css-extract-plugin
export default {"tagContainer":"Tags_tagContainer__sePOE"};